export default __webpack_public_path__ + "img/img/mastercard.4ad8ed0d.svg";